/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function CalendarIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "calendar", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M4.5 10.5V19.5H20.5V10.5M4.5 10.5V5.5H20.5V10.5M4.5 10.5H12.5H20.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7.5 8V3", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M20.5 13.5H4.5M20.5 16.5H4.5M16.5 10.5V19.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 19.5V10.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8.5 10.5V19.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M17.5 8V3", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(CalendarIcon);
export default ForwardRef;
//# sourceMappingURL=calendarIcon.js.map